import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, HostBinding } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { DirectivesModule } from '@directives/directives.module';

@Component({
  selector: 'app-product-card',
  imports: [
    CommonModule,
    CsIconModule,
    DirectivesModule,
    NgTemplateOutlet
  ],
  templateUrl: './product-card.component.html',
  styles: [':host { @apply tw-flex tw-flex-col; }'],
  standalone: true
})
export class ProductCardComponent {
  @Input() product: any;
  @Input() productInCart: any;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() variant: 'default' | 'bottomsheet' = 'default';
  @Input() isShopRevampExperimentOn: boolean;
  @Output() gotoProduct: EventEmitter<any> = new EventEmitter();
  @Output() addToCart: EventEmitter<any> = new EventEmitter();
  @Output() reomveFromCart: EventEmitter<any> = new EventEmitter();

  @HostBinding('style.width') get hostWidth() {
    return this.widthValue();
  }

  @HostBinding('style.min-width') get hostMinWidth() {
    return this.widthValue();
  }

  private widthValue(): string {
    const sizeMap = {
      sm: '96px',
      md: '144px', // Default current width
      lg: '180px'
    };
    return sizeMap[this.size];
  }

  // Getter to handle both formats: number or { quantity: number }
  get productQuantity(): number {
    if (!this.productInCart) return 0;

    // If productInCart is an object with quantity property
    if (typeof this.productInCart === 'object' && this.productInCart.quantity !== undefined) {
      return this.productInCart.quantity;
    }

    // If productInCart is just a number
    if (typeof this.productInCart === 'number') {
      return this.productInCart;
    }

    return 0;
  }

  addToCartAction(product: any, image: HTMLImageElement): void {
    this.addToCart.emit({ product, image })
  }

  removeFromCartAction(product : any): void {
    this.reomveFromCart.emit(product)
  }
}
